export default __webpack_public_path__ + "static/media/empty-coaches-switch.9cacc297.svg";